import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { IoLocationSharp } from "react-icons/io5";
import '../../src/index.css'
import { FaWeightScale, FaUserShield, FaSquarePollVertical } from "react-icons/fa6";
import { FaPeopleGroup, FaUsersGear } from "react-icons/fa6";
import { BsFillCalendarCheckFill } from "react-icons/bs";
import { useTheme } from '@material-ui/core/styles';
import { BiIntersect } from "react-icons/bi";
import { BsClipboard2DataFill } from "react-icons/bs";
import { TbFilterEdit } from "react-icons/tb";
import { FaFileContract } from "react-icons/fa";
import { TfiAgenda } from "react-icons/tfi";


const useStyles = makeStyles({
  root: {
    maxWidth: '100%',
    height: 230,
    borderRadius: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  media: {
    height: 140,
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  iconColumn: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textColumn: {
    flex: '2',
    marginLeft: "2%",
  },
  title: {
    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
    fontSize: '40px',
    fontWeight: 'bold',
  },
  message: {
    fontFamily: "'Segoe UI Variable Static Text 300', sans-serif",
    fontSize: '18px',
    lineHeight: '1.2',
    maxWidth: '248px',
  },
});

export default function SimpleCard({ title, messageInfo, subtitle, img, event }) {
  const classes = useStyles();
  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;

  return (
    <>
      <br></br>
      <Card className={classes.root}>
        <CardActionArea onClick={(e) => { event() }}>
          <CardContent className={classes.contentContainer}>
            <div className={classes.iconColumn}>
              {img === "mapa" && <IoLocationSharp className='iconosHome' style={{ color: primaryColor }}></IoLocationSharp>}
              {img === "bascula" && <FaWeightScale className='iconosHome' style={{ color: primaryColor }}></FaWeightScale>}
              {img === "administracion" && <FaUserShield className='iconosHome' style={{ color: primaryColor }}></FaUserShield>}
              {img === "clientes" && <FaPeopleGroup className='iconosHome' style={{ color: primaryColor }}></FaPeopleGroup>}
              {img === "años" && <BsFillCalendarCheckFill className='iconosHome' style={{ color: primaryColor }}></BsFillCalendarCheckFill>}
              {img === "adminuser" && <FaUsersGear className='iconosHome' style={{ color: primaryColor }}></FaUsersGear>}
              {img === "encuestas" && <FaSquarePollVertical className='iconosHome' style={{ color: primaryColor }}></FaSquarePollVertical>}
              {img === "modulos" && <BiIntersect className='iconosHome' style={{ color: primaryColor }}></BiIntersect>}
              {img === "datos" && <BsClipboard2DataFill className='iconosHome' style={{ color: primaryColor }}></BsClipboard2DataFill>}
              {img === "multifiltro" && <TbFilterEdit className='iconosHome' style={{ color: primaryColor }}></TbFilterEdit>}
              {img === "RegistroDeMediciones" && <FaFileContract className='iconosHome' style={{ color: primaryColor }}></FaFileContract>}
              {img === "validacion" && <TfiAgenda className='iconosHome' style={{ color: primaryColor }}></TfiAgenda>}


            </div>
            <div className={classes.textColumn}>
              <Typography className={classes.title} gutterBottom variant="h5" component="h2" align='left' style={{ color: primaryColor }}>
                {title}
              </Typography>
              <Typography className={classes.message} variant="body2" color="textSecondary" component="p" align='left' style={{ color: primaryColor }}>
                {messageInfo}
              </Typography>
              {
                subtitle && (
                  <Typography variant="caption" component="p" align='left' style={{ color: primaryColor, marginTop: 2 }}>
                    {subtitle}
                  </Typography>
                )
              }
            </div>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}
